import React from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";

export default function TenantCardError({ error, onClose }) {

    const { t } = useTranslation([
        "tenant/tenant",
    ], {
        useSuspense: false
    });
    // render into document.body so it floats above everything
    return ReactDOM.createPortal(
        <div className="error-modal-overlay" onClick={onClose}>
            <div
                className="error-modal"
                onClick={e => e.stopPropagation() /* prevent overlay click from closing when clicking inside */}
            >
                <div className="error-modal-header">
                    <div className="error-modal-title">
                        <i className="fas fa-exclamation-circle error-icon"></i>
                        <span className="error-modal-title-text">
                            {t("tenant/tenant:error_details")}
                        </span>
                    </div>
                    <button
                        type="button"
                        className="error-close-btn"
                        aria-label="Close"
                        onClick={onClose}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div className="error-modal-body">
                    {error}
                </div>

                <div className="error-modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onClose}
                    >
                        {t("tenant/tenant:cancel")}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}
